import { EventSubscriber } from '@a-type/utils';
export const dndEvents = new EventSubscriber();
//# sourceMappingURL=dndEvents.js.map